import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { get, map, flatten, isEmpty } from "lodash";

import Box from "@material-ui/core/Box";

import MultiLevelSelect from "./MultiLevelSelect";

const CompaniesSitesZonesSelect = (props) => {
  const { formValue, setFormValue } = props;

  const [companies, setCompanies] = React.useState();

  React.useEffect(() => {
    setCompanies(get(props, ["companies"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!isEmpty(companies)) {
      setFormValue(
        map(
          flatten(
            map(companies, (c) =>
              flatten(map(get(c, ["sites"]), (s) => get(s, ["zones"])))
            )
          ),
          (s) => get(s, ["id"])
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies]);

  const options = map(companies, (c) => ({
    ...c,
    options: map(c.sites, (s) => ({
      ...s,
      options: s.zones,
    })),
  }));

  return (
    <Box>
      <Box className="text-87 bold-500" style={{ display: "flex" }}>
        {I18n.get("common_companiesSitesZones")}
      </Box>
      <MultiLevelSelect
        name="companiesSitesZones"
        values={formValue}
        onChange={setFormValue}
        options={options}
      />
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: get(state, ["user", "companies"]),
  };
};

export default connect(mapStateToProps)(CompaniesSitesZonesSelect);
